module.exports = __webpack_public_path__ + "img/marker-orange.63ae12b3.svg";